export enum ICON_SIZE {
    SMALL = "small",
    MEDIUM = 'medium',
}

export interface IconProps {
    color?: string;
    size?: ICON_SIZE;
}
